<template lang="pug">
  app-toolbar
    app-toolbar-item(label="Выбрать тег" :items="filteredTags" all="все" key-name="hashtag" @select="setFilterTag") {{ filterTag ? filterTag.hashtag : 'все' }}
    app-toolbar-item-period.ml-6(@select="setPeriod") {{ period ? period.text : 'все' }}
    app-toolbar-item.ml-6(label="Сортировать" :items="sorters" key-name="name" @select="setSorter") {{ sorter.name }}
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  name: 'file-store-toolbar',
  computed: {
    ...mapState('fileStore', ['period', 'filterTag', 'sorter', 'sorters']),
    ...mapGetters('fileStore', ['sortedTags', 'templatesByPath']),

    filteredTags () {
      return this.sortedTags.filter(path => this.templatesByPath(path).length > 0)
    }
  },
  methods: mapMutations('fileStore', ['setPeriod', 'setFilterTag', 'setSorter'])
}
</script>